<template>
  <div id="fileList">
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range
            class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol v-if="$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="orgSelect.options" :data="orgSelect.data" ref="orgSelect"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseSelect :options="typeSelect.options" :data="typeSelect.data" ref="typeSelect"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseInput :options="titleInput.options" :data="titleInput.data" :listener="titleInput.listener" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary" @click="$router.push('/files-screen-management/upload-screen.html')">
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow class="row-2">

    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-else></td>
          </template>
          <template #description="{ item }">
            <td>
              <span :key="item.description" class="description" v-c-tooltip.hover="item.description">{{
              item.description
              }}</span>
            </td>
          </template>
          <template #status="{item}">
            <td>
              <span v-if="item.status == 1" class="dot-custom dot-warning">
                Đang xử lý
              </span>
              <span v-else-if="item.status == 2" class="dot-custom  dot-success">
                Đã xử lý
              </span>
              <span v-else-if="item.status == 3" class="dot-custom  dot-danger">
                Xử lý lỗi
              </span>
            </td>
          </template>
          <template #type="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.type == 0 && item.isRun == true">Văn bản - Chữ chạy</span>
              <span class="badge badge-light" v-else-if="item.type == 0 && item.isRun == false">Văn bản - Thông
                báo</span>
              <span class="badge badge-light" v-else-if="item.type == 1">Hình ảnh</span>
              <span class="badge badge-light" v-else-if="item.type == 2">Video</span>
              <span class="badge badge-light" v-else-if="item.type == 3">RSS</span>
              <span class="badge badge-light" v-else-if="item.type == 4">Tài liệu / {{
              item.url.substring(item.url.lastIndexOf(".") + 1, item.url.length)
              }}</span>
              <span class="badge badge-light" v-else-if="item.type == 5">Kênh trực tuyến</span>
            </td>
          </template>
          <template #url="{ item }">
            <td v-if="item.url != null">
              <span class="view-file" v-if="item.type != 3 && item.type != 5 && item.status == 2"
                @click="viewFile(item.type, item.title, item.url, item.content)">Ấn vào để xem</span>
            </td>
            <td v-else></td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton :disabled="item.type != 2 || item.status != 2"
                  :style="item.type != 2 || item.status != 2 ? 'cursor:no-drop' : ''" color="info" variant="outline"
                  v-c-tooltip.hover="'Gán mặc định cho thiết bị'" square size="sm" @click="clickConfigDefault(item)"><i
                    class="fa fa-cogs"></i>
                </CButton>
                <CButton :disabled="item.type == 0 || item.type == 3 || item.type == 5"
                  :style="item.type == 0 || item.type == 3|| item.type == 5 ? 'cursor:no-drop' : ''" color="info"
                  variant="outline" v-c-tooltip.hover="'Tải xuống'" square size="sm" @click="downloadFile(item)"><i
                    class="fa fa-download"></i>
                </CButton>
                <CButton color="danger" variant="outline" square size="sm" v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.title)">
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Nội dung bản tin" :show.sync="isShowPopupContent" :closeOnBackdrop="false" size="lg">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            {{ contentDetail }}
          </CForm>
        </CCol>
      </CRow>
      <div slot="footer">
        <CButton color="secondary" class="btn-action-primary" @click="isShowPopupContent = false"><i
            class="fa fa-times"></i> Đóng
        </CButton>
      </div>
    </CModal>

    <BaseModal v-if="isShowPopupCkEditor" :title="'Xem bản tin: ' + viewFileTitle" :show.sync="isShowPopupCkEditor"
      size="xl" :closeOnBackdrop="false">
      <template v-slot:body-wrapper>
        <div class="modal-body content-fade-in" style="max-height: 80vh;">
          <template>
            <ckeditor :editor="editor" v-model="contentDetail" :config="editorConfig" :readonly="true" :disabled="true"></ckeditor>
          </template>
        </div>
      </template>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="isShowPopupCkEditor = false"
            :disabled="loadingShareFile.value"><i class="fa fa-close"></i> Đóng
          </button>&nbsp;
        </div>
      </template>
    </BaseModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>

    <BaseModal v-if="isShowModalViewFile" :title="'Xem bản tin: ' + viewFileTitle" :show.sync="isShowModalViewFile"
      size="xl" :closeOnBackdrop="false">
      <template v-slot:body-wrapper>
        <div class="modal-body content-fade-in" style="max-height: 80vh;">
          <template v-if="typeViewFile == 1">
            <img :src="viewFileUrl" :alt="viewFileUrl"
              style="width: 100%;height: 100%;max-height: 75vh;object-fit: contain">
          </template>
          <template v-else-if="typeViewFile == 2">
            <VideoPlayer style="width: 100%;height: auto;max-height: 76vh;" :manifest-url="viewFileUrl"
              :poster-url="posterUrl" />
          </template>
          <template v-else-if="typeViewFile == 4">
            <iframe :src="viewFileUrl" frameborder="0" style="width: 100%;min-height: 75vh"></iframe>
          </template>
        </div>
      </template>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="isShowModalViewFile = false"
            :disabled="loadingShareFile.value"><i class="fa fa-close"></i> Đóng
          </button>&nbsp;
        </div>
      </template>
    </BaseModal>

    <BaseModal v-if="isShowPopupConfigDefault" :title="'Gán bản tin: ' + viewFileTitle + ' mặc định cho thiết bị'"
      :show.sync="isShowPopupConfigDefault" size="lg" :closeOnBackdrop="false">
      <template v-slot:body-wrapper>
        <div class="modal-body content-fade-in" style="max-height: 80vh;">
          <CRow>
            <CCol xs="12" sm="12" md="12" lg="12" xl="12">
              <div class="form-group">
                <label style="display: inline-flex;margin-bottom: 0.5rem!important;">Thiết bị
                  <span class="required">*</span>
                  <CInputCheckbox custom :checked="isSelectedAllDevices" class="ml-2"
                    @update:checked="changeSelectedAllDevice($event)" addInputClasses="override-custom">
                  </CInputCheckbox>
                  Chọn tất cả
                </label>

                <multiselect id="deviceSelect" v-model="dataConfigDefault.deviceInput.data.model"
                  placeholder="Chọn thiết bị" label="text" track-by="value"
                  :options="dataConfigDefault.deviceInput.options" selectLabel="Chọn" deselectLabel="Bỏ chọn"
                  selectedLabel="Đã chọn" :close-on-select="false" :class="dataConfigDefault.classDeviceSelect"
                  :multiple="true">
                  <span slot="noResult">Không có dữ liệu tương ứng!</span>
                  <span slot="noOptions">Danh sách rỗng!</span>
                </multiselect>
                <div class="valid-error"
                  v-show="!(dataConfigDefault.deviceInput.data.validator ? dataConfigDefault.deviceInput.data.validator.isValid : true)">
                  {{
                  dataConfigDefault.deviceInput.data.validator
                  ? dataConfigDefault.deviceInput.data.validator.errorMessage
                  : ""
                  }}
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      </template>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="isShowPopupConfigDefault = false"><i
              class="fa fa-close"></i> Hủy bỏ
          </button>&nbsp;
          <button type="button" class="btn btn-primary" @click="submitConfigDefault()"
            :disabled="loadingShareFile.value"><i class="fa fa-check"></i> Xác nhận
          </button>&nbsp;
        </div>
      </template>
    </BaseModal>

  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";
import { DatePicker } from "v-calendar";
import VideoPlayer from "@/views/base/VideoPlayer";
import Multiselect from "vue-multiselect";
import DecoupledDocumentEditor from '/public/static/js/ckeditor.js';

export default {
  name: "ScreenFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    BaseModal,
    VideoPlayer,
    Multiselect,
    DecoupledDocumentEditor
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/screen-file/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "bản tin",
          that.actionData.model.fileName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.fileId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({ message: "Xóa bản tin " + that.actionData.model.fileName + " thành công" });
        that.loadDataMainTable();
      }
    });
    return {
      isSelectedAllDevices: false,
      typeViewFile: "",
      viewFileUrl: "",
      viewFileTitle: "",
      posterUrl: '',
      loading: {
        value: false,
      },
      editor: DecoupledDocumentEditor,
      editorConfig: {
      },
      isShowModalViewFile: false,
      isShowPopupContent: false,
      isShowPopupConfigDefault: false,
      isShowPopupCkEditor: false,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      dataConfigDefault: {
        fileIdInput: {
          data: {
            name: "fileId",
            model: "",
          }
        },
        classDeviceSelect: '',
        deviceInput: {
          options: [],
          data: {
            name: "devices",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataConfigDefault.deviceInput.data.model;
                if (value === "" || value.length == 0) {
                  this.isValid = false;
                  // dataConfigDefault.deviceInput.data.validator.isValid === false ? 'input-error' : ''
                  this.errorMessage = "Thiết bị không được để trống";
                  that.dataConfigDefault.classDeviceSelect = 'input-error'
                } else {
                  this.isValid = true;
                  that.dataConfigDefault.classDeviceSelect = ''
                }
                return this.isValid;
              },
            },
          },
        },
      },
      loadingShareFile: { value: false },
      contentDetail: "",
      dateRange: {
        start: that.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      orgSelect: {
        options: {
          label: "Đơn vị",
          selectAllText: "Tất cả đơn vị",
          filter: true,
          keyField: "value",
          valueField: "text",
          lazyLoad: that.$hasAuthor("ROLE_ADMIN") ? false : true
        },
        data: {
          model: "",
          name: "orgId",
          source: {
            url: "/organization/list-org-active",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      typeSelect: {
        options: {
          filter: false,
          label: "Loại bản tin",
        },
        data: {
          name: "type",
          items: [
            { key: "null", value: "Tất cả loại bản tin" },
            { key: "0", value: "Văn bản" },
            { key: "1", value: "Hình ảnh" },
            { key: "2", value: "Video" },
            { key: "3", value: "RSS" },
            { key: "4", value: "Tài liệu" },
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "STT", sorter: false, filter: false },
            { key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%" },
            { key: "title", label: "Tiêu đề" },
            { key: "description", label: "Mô tả", sorter: false, filter: false },
            { key: "url", label: "Nội dung bản tin", sorter: false, filter: false },
            { key: "duration", label: "Thời lượng phát" },
            { key: "type", label: "Loại bản tin" },
            { key: "status", label: "Trạng thái tệp tin" },
            { key: "action", label: "Thao tác", sorter: false, filter: false },
          ],
          slots: [
            "index",
            "createDate",
            "action",
            "url",
            "type",
            "description", "status"
          ],
          pageSize: 15,
          sorter: true,
          columnFilter: false,
          tableFilter: false,
          // tableFilter: {
          //   label: 'Bộ lọc: ',
          //   placeholder: 'Nhập từ khóa'
          // },
          // clickableRows: true,
          // hover: true
        },
        dataSource: {
          url: "/screen-file/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            params.orgId = that.orgSelect.data.model;
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    changeSelectedAllDevice(value) {
      if (value) {
        this.dataConfigDefault.deviceInput.data.model = this.dataConfigDefault.deviceInput.options;
      } else {
        this.dataConfigDefault.deviceInput.data.model = '';
      }
    },
    loadDataDevices() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/find-all",
        dataSubmit: function () {
          return {
            orgId: ''
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.dataConfigDefault.deviceInput.options = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    viewFile(type, title, url, content) {
      if (type === 0) {    /* Type = 0 là dạng văn bản */
        this.isShowPopupContent = true;
        this.contentDetail = content;
      } else if (type === 1 || type === 2) {/* Type = 1 là dạng hình ảnh, Type = 2 là dạng video */
        this.typeViewFile = type;
        this.viewFileUrl = url;
        this.isShowModalViewFile = true;
      } else if (type === 4) { /* Type = 4 là dạng tài liệu */
        var fileType = url.substring(url.lastIndexOf("."), url.length);
        this.typeViewFile = type;
        // this.viewFileUrl = "https://docs.google.com/gview?url=" + url + "&embedded=true";
        this.isShowModalViewFile = true;
        if (fileType === '.pdf') {
          this.viewFileUrl = url;
        } else if (fileType === '.doc' || fileType === '.docx') {
          this.viewFileUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
        }
      } else if (type === 6) { /* Type = 6 là dạng ckeditor */
        this.isShowPopupCkEditor = true;
        this.contentDetail = content;
      }
      this.viewFileTitle = title;
    },
    async downloadFile(item) {
      var url;
      if (item.type == 2) {
        if (item.url && item.pathFolderFile) {
          var itemsFile = item.pathFolderFile.split("/");
          var nameFile = itemsFile[itemsFile.length - 1];
          var urlFile = item.url.substring(0, item.url.lastIndexOf("/"));
          url = urlFile + "/" + nameFile
        }
      } else {
        url = item.url;
      }
      this.loading.value = true;
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      a.click();
    },
    setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
      let actionData = this.actionData.model;
      actionData.fileId = fileId || null;
      actionData.fileName = fileName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    clickConfigDefault(item) {
      this.loadDataDevices();
      this.dataConfigDefault.fileIdInput.data.model = item.id;
      this.viewFileTitle = item.title;
      this.isShowPopupConfigDefault = true;
    },
    submitConfigDefault() {
      let that = this;
      if (!this.dataConfigDefault.deviceInput.data.validator.valid()) {
        return;
      }
      let devices = [];
      for (let i = 0; i < that.dataConfigDefault.deviceInput.data.model.length; i++) {
        devices.push(that.dataConfigDefault.deviceInput.data.model[i].value);
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/screen-file/configDefault",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            fileId: that.dataConfigDefault.fileIdInput.data.model,
            deviceIds: devices,
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({ message: "Gán mặc định cho thiết bị thành công" });
            that.dataConfigDefault.deviceInput.data.model = [];
            that.isShowPopupConfigDefault = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
    if (this.$hasAuthor('ROLE_ADMIN')) {
      this.typeSelect.data.items.push({ key: 5, value: 'Kênh trực tuyến' })
    }
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    isShowPopupConfigDefault(value) {
      if (!value) {
        this.dataConfigDefault.deviceInput.data.validator.isValid = false;
        this.dataConfigDefault.deviceInput.data.validator.errorMessage = '';
        this.dataConfigDefault.classDeviceSelect = '';
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}
</style>
<style lang="scss">
#fileList {
  .multiselect {
    min-height: 36px !important;
    margin-top: -2px;

    &.input-error .multiselect__tags {
      border-color: #ff7070;
    }

    .valid-error {
      animation: fade-down ease-out .2s;
      animation-fill-mode: forwards;
    }

    .multiselect__tags {
      padding-top: 0px !important;
      min-height: 36px !important;
    }


    .multiselect__tag {
      margin-top: 5px !important;
      margin-bottom: 0 !important;
    }
  }

  .multiselect__input {
    line-height: unset !important;
    font-size: 14px !important;
    padding-top: 5px !important;
  }


  .multiselect__placeholder {
    padding-top: 7px !important;
    margin: 0 !important;
  }
}
</style>
